import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.reverse.js";
import styled, { css } from 'styled-components';
import { spacing } from 'styles/globals';
import GridItem, { gridItemClassName } from './GridItem';
var DEFAULT_SPACING = 's';
var Grid = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['spacing', 'hasBottomSpacing', 'reverse'].includes(prop);
  }
}).withConfig({
  displayName: "Grid",
  componentId: "sc-1eufgm0-0"
})(["display:flex;flex-wrap:wrap;margin-left:-", ";& > .", "{padding-left:", ";}margin-bottom:-", ";& > .", "{padding-bottom:", ";}", ""], function (p) {
  return spacing[p.spacing || DEFAULT_SPACING];
}, gridItemClassName, function (p) {
  return spacing[p.spacing || DEFAULT_SPACING];
}, function (p) {
  return p.hasBottomSpacing && spacing[p.spacing || DEFAULT_SPACING];
}, gridItemClassName, function (p) {
  return p.hasBottomSpacing && spacing[p.spacing || DEFAULT_SPACING];
}, function (p) {
  return p.reverse && css(["direction:rtl;text-align:left;& > .", "{direction:ltr;text-align:left;}"], gridItemClassName);
});
export { Grid, GridItem };
export default Grid;